import * as React from 'react'
import * as styles from '../assets/styles.module.scss'
import { default as Header } from './common/header'
import { default as Heroshot } from './common/heroshot'
import { default as Footer } from './common/footer'

import { default as Tagline } from './homepage/Tagline'
import { default as Contact } from './homepage/Contact'

export default class Page extends React.Component<{}, {}> {
    public render() {
        return (
            <section className={styles.Container}>
                <Header title="Not Found | Juvasoft" />
                <Heroshot title={`Oop's! We couldn't find what you were looking for`}
                subtitle={`
                    We partner with small, mid-size and enterprises to 
                    design and develop game-changing digital products
                    and services, from napkin to market.`} />
                <div className={styles.Homepage}>
                    <Tagline />
                    <Contact />
                </div>
                <Footer />
            </section>
        )
    }
}